import { create } from 'zustand'
import type { CreateBusinessFormValues } from '../schemas/createBusinessSchema'

const EMPTY: CreateBusinessFormValues = {
  legalName: '',
  description: '',
  logo: '',
  businessCategoryIds: [],
  packageServiceIds: [],
  useSameOrgAddress: false,
  licenseType: 'MONTHLY',
  plannedDayToPay: null,
  address: {
    street1: '',
    city: '',
    // Sin selección: LocationFields obliga a elegir país/provincia/municipio
    // reales (y autoselecciona el país si solo hay uno).
    countryId: 0,
    provinceId: 0,
    municipalityId: 0,
    isMain: true,
  },
}

interface CreateBusinessFormStore {
  values: CreateBusinessFormValues
  setValues: (next: Partial<CreateBusinessFormValues>) => void
  reset: () => void
}

export const useCreateBusinessFormState = create<CreateBusinessFormStore>((set) => ({
  values: EMPTY,
  setValues: (next) =>
    set((state) => ({
      values: { ...state.values, ...next },
    })),
  reset: () => set({ values: EMPTY }),
}))
